/*
 * 报税题下面所有的日期配置
 * 印花税 + 企业税 + 增值税 一共6种
 */
export function reportTaxDateConfig(currentQa) {
    let config = reactive({})

    const yibanName = '北京仁和服饰有限公司' // 一般公司名
    const xiaoGuiMoName = '北京梦园商贸有限公司' // 小规模公司名

    const checkRule = currentQa.checkRule && JSON.parse(currentQa.checkRule) || {}

    const month = checkRule?.taxOwnershipStart?.substring(5, 7)
    let yue = month && month + '月' || null
    let jiDu = null
    switch (month) {
        case '01':
        case '02':
        case '03':
            jiDu = '一季度'
            break
        case '04':
        case '05':
        case '06':
            jiDu = '二季度'
            break
        case '07':
        case '08':
        case '09':
            jiDu = '三季度'
            break
        case '10':
        case '11':
        case '12':
            jiDu = '四季度'
            break
    }

    config.creditCode = checkRule.creditCode

    switch (currentQa.sonQueType) {
        case '21': // 增值税--小规模---对应1组件
            config.finishDeadline = checkRule.deadlineProcessing ?? '2024-07-15' // 办理期限
            config.taxDurationTime = jiDu ?? '二季度' //税款所属期 月份
            config.taxStartTime = checkRule.taxOwnershipStart ?? '2024-04-01' // 税款所属期
            config.taxEndTime = checkRule.taxOwnershipEnd ?? '2024-06-30'
            config.fillFormDate = checkRule.declaration ?? '2024-07-01' // 填报日期(表格里面的)
            config.companyName = checkRule.companyName ?? xiaoGuiMoName
            config.creditCode = checkRule.creditCode ?? '91420108MA68AUED0W' // 统一社会信用代码
            break
        case '23': // 增值税--一般---对应3组件
            config.finishDeadline = checkRule.deadlineProcessing ?? '2025-01-15' // 办理期限
            config.taxDurationTime = yue ?? '12月' //税款所属期 月份
            config.taxStartTime = checkRule.taxOwnershipStart ?? '2024-12-01' // 税款所属期
            config.taxEndTime = checkRule.taxOwnershipEnd ?? '2024-12-31'
            config.fillFormDate = checkRule.declaration ?? '2025-01-03' // 填报日期(表格里面的)
            config.companyName = checkRule.companyName ?? yibanName
            config.creditCode = checkRule.creditCode ?? '91110104533585261H' // 统一社会信用代码
            config.registerAdd = '北京市东城区和平里东街3号' // 注册地
            config.productAdd = '北京市东城区和平里东街3号' // 生产经营地
            config.openBankName = '工行北京和平里北街支行' // 开户行
            config.openBankAccount = '020003308018000655446' // 开户账号
            config.telephoneNumber = '010-64278838' // 公司电话
            break
        case '2601':
        case '26': // 企税--一般---对应2组件
            config.finishDeadline = checkRule.deadlineProcessing ?? '2025-01-15' // 办理期限
            config.taxDurationTime = jiDu ?? '四季度' //税款所属期 月份
            config.taxStartTime = checkRule.taxOwnershipStart ?? '2024-10-01' // 税款所属期
            config.taxEndTime = checkRule.taxOwnershipEnd ?? '2024-12-31'
            config.fillFormDate = checkRule.declaration ?? '2025-01-03' // 填报日期(表格里面的)
            config.companyName = checkRule.companyName ?? yibanName
            config.jmzc = '434.42' // 季末资产总额写死
            break
        case '2201' :
        case '22': // 企税--小规模---对应2组件
            config.finishDeadline = checkRule.deadlineProcessing ?? '2024-07-15' // 办理期限
            config.taxDurationTime = jiDu ?? '二季度' //税款所属期 月份
            config.taxStartTime = checkRule.taxOwnershipStart ?? '2024-04-01' // 税款所属期
            config.taxEndTime = checkRule.taxOwnershipEnd ?? '2024-06-30'
            config.fillFormDate = checkRule.declaration ?? '2024-07-01' // 填报日期(表格里面的)
            config.companyName = checkRule.companyName ?? xiaoGuiMoName
            config.jmzc = '29.93' // 季末资产总额写死
            break
        case '24': // 印花税--小规模
            config.finishDeadline = checkRule.deadlineProcessing ?? '2024-07-15' // 办理期限
            config.taxDurationTime = jiDu ?? '二季度' //税款所属期 月份
            config.taxStartTime = checkRule.taxOwnershipStart ?? '2024-04-01' // 税款所属期
            config.taxEndTime = checkRule.taxOwnershipEnd ?? '2024-06-30'
            config.fillFormDate = checkRule.declaration ?? '2024-07-01' // 填报日期(表格里面的)
            config.companyName = checkRule.companyName ?? xiaoGuiMoName
            break
        case '25': // 印花税--一般
            config.finishDeadline = checkRule.deadlineProcessing ?? '2025-01-15' // 办理期限
            config.taxDurationTime = jiDu ?? '四季度' //税款所属期 月份
            config.taxStartTime = checkRule.taxOwnershipStart ?? '2024-10-01' // 税款所属期
            config.taxEndTime = checkRule.taxOwnershipEnd ?? '2024-12-31'
            config.fillFormDate = checkRule.declaration ?? '2025-01-03' // 填报日期(表格里面的)
            config.companyName = checkRule.companyName ?? yibanName
            break
        case '27': // 财务报表报送（季度）（一般纳税人）
            config.finishDeadline = checkRule.deadlineProcessing// 办理期限
            config.taxDurationTime = jiDu //税款所属期 月份
            config.taxStartTime = checkRule.taxOwnershipStart // 税款所属期
            config.taxEndTime = checkRule.taxOwnershipEnd
            config.fillFormDate = checkRule.declaration// 填报日期(表格里面的)
            config.belongYear = checkRule.taxOwnershipStart && checkRule.taxOwnershipStart.substring(0, 4) || ''
            config.companyName = checkRule.companyName ?? yibanName
            break
        case '28': // 财务报表报送（季度）（小规模纳税人）
            config.finishDeadline = checkRule.deadlineProcessing// 办理期限
            config.taxDurationTime = jiDu //税款所属期 月份
            config.taxStartTime = checkRule.taxOwnershipStart // 税款所属期
            config.taxEndTime = checkRule.taxOwnershipEnd
            config.fillFormDate = checkRule.declaration// 填报日期(表格里面的)
            config.belongYear = checkRule.taxOwnershipStart && checkRule.taxOwnershipStart.substring(0, 4) || ''
            config.companyName = checkRule.companyName ?? xiaoGuiMoName
            break
        case '29': // 汇算清缴-财务报表报送
            config.finishDeadline = checkRule.deadlineProcessing// 办理期限
            config.taxDurationTime = jiDu //税款所属期 月份
            config.taxStartTime = checkRule.taxOwnershipStart // 税款所属期
            config.taxEndTime = checkRule.taxOwnershipEnd
            config.fillFormDate = checkRule.declaration// 填报日期(表格里面的)
            config.belongYear = checkRule.taxOwnershipStart && checkRule.taxOwnershipStart.substring(0, 4) || ''
            config.companyName = checkRule.companyName ?? yibanName
            break
        case '201': // 汇算清缴-企业所得税年度申报
            config.taxStartTime = checkRule.taxOwnershipStart // 税款所属期
            config.taxEndTime = checkRule.taxOwnershipEnd
            config.finishDeadline = checkRule.deadlineProcessing// 办理期限
            config.companyName = checkRule.companyName ?? yibanName
            break
    }

    return {
        staticConfig: config,
    }
}
